import { useState } from "react";
import { ScanLine, CheckCircle2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg, fmtDateTime } from "@/lib/api";

export function RedeemTicket() {
  const [code, setCode] = useState("");
  const [result, setResult] = useState(null);
  const redeem = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    try {
      const { data } = await api.post(`/sale-tickets/${encodeURIComponent(code.trim())}/redeem`);
      setResult({ ok: true, text: `Liberado: 1x ${data.product_name}`, sub: `Venda #${data.sale_number} · ${fmtDateTime(data.created_at)}` });
    } catch (err) {
      setResult({ ok: false, text: errMsg(err), sub: code.toUpperCase() });
    }
    setCode("");
  };
  return (
    <div className="card-surface p-6 max-w-xl space-y-4" data-testid="redeem-ticket">
      <p className="text-sm text-muted-foreground">Leia o código com o leitor ou digite o código impresso no ticket. Cada ticket só pode ser usado uma vez.</p>
      <form onSubmit={redeem} className="flex gap-2">
        <Input autoFocus value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="Código do ticket" className="h-14 font-mono text-xl tracking-[0.3em]" data-testid="redeem-code-input" />
        <Button type="submit" className="h-14 px-6" data-testid="redeem-submit-btn"><ScanLine className="h-5 w-5 mr-2" />Dar baixa</Button>
      </form>
      {result && (
        <div className={`flex items-center gap-3 rounded-xl p-4 ${result.ok ? "bg-emerald-500/15 text-emerald-500" : "bg-red-500/15 text-red-500"}`} data-testid="redeem-result">
          {result.ok ? <CheckCircle2 className="h-8 w-8" /> : <XCircle className="h-8 w-8" />}
          <div><p className="text-lg font-bold">{result.text}</p><p className="text-sm opacity-80">{result.sub}</p></div>
        </div>
      )}
    </div>
  );
}
